import React, { useEffect, useState, useContext } from "react";
import { Outlet } from "react-router-dom";
import MobileMenuSection from "../pages/ClientPage/MobileMenuSection";
import AnouncementsService from "../Api/AnouncementsService";
import socialLinks from '../utils/socialLinks';

const ClientLayout = () => {

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [announcements, setAnnouncements] = useState([]);

    const anouncementsService = new AnouncementsService();

    useEffect(() => {
        const fetchPublicAnnouncements = async () => {
            try {
                const response = await anouncementsService.GetPublicAnouncements(1, 1);
                const items = Array.isArray(response?.data?.data) ? response.data.data : [];
                setAnnouncements(items);
            } catch (error) {
                setAnnouncements([]);
            }
        };
        fetchPublicAnnouncements();
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };
    return (

        <>

            {/* Start Header Area */}
            <header className="rbt-header rbt-header-10">
                <div className="rbt-sticky-placeholder" />
                {/* Start Header Top  */}
                <div className="rbt-header-top rbt-header-top-1 header-space-betwween bg-not-transparent bg-color-darker top-expended-activation">
                    <div className="container-fluid">
                        <div className="top-expended-wrapper">
                            <div className="top-expended-inner rbt-header-sec align-items-center ">
                                <div className="rbt-header-sec-col rbt-header-left d-none d-xl-block">
                                    <div className="rbt-header-content">
                                        {/* Start Header Information List  */}
                                        <div className="header-info">
                                            <ul className="rbt-information-list">
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-instagram" />
                                                        100k{" "}
                                                        <span className="d-none d-xxl-block">Followers</span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="fab fa-facebook-square" />
                                                        500k{" "}
                                                        <span className="d-none d-xxl-block">Followers</span>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#">
                                                        <i className="feather-phone" />
                                                        +91-7808780874
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        {/* End Header Information List  */}
                                    </div>
                                </div>
                                <div className="rbt-header-sec-col rbt-header-center">
                                    <div className="rbt-header-content justify-content-start justify-content-xl-center">
                                        <div className="header-info">
                                            <div className="rbt-header-top-news">
                                                <div className="inner">
                                                    <div className="content">
                                                        <span className="rbt-badge variation-02 bg-color-primary color-white radius-round">
                                                            Hot
                                                        </span>
                                                        {announcements.length > 0 ? (
                                                            <span className="news-text">
                                                                <img
                                                                    src="assets1/images/icons/hand-emojji.svg"
                                                                    alt="Hand Emojji Images"
                                                                />{" "}
                                                                {announcements.map(a => (
                                                                    <span key={a.id}>
                                                                        <strong>{a.title}</strong>: {a.content}{" "}
                                                                    </span>
                                                                ))}
                                                            </span>
                                                        ) : (
                                                            <span className="news-text">No announcements</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="rbt-header-sec-col rbt-header-right mt_md--10 mt_sm--10">
                                    <div className="rbt-header-content justify-content-start justify-content-lg-end">
                                        <div className="header-info d-none d-xl-block">
                                            <ul className="social-share-transparent">
                                                <li>
                                                    <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-facebook-f" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-twitter" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href={socialLinks.youtube} target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-youtube" />
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
                                                        <i className="fab fa-instagram" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="rbt-separator d-none d-xl-block" />
                                        <div className="header-info">
                                            <ul className="rbt-dropdown-menu switcher-language">
                                                <li className="has-child-menu">
                                                    <a href="#">
                                                        <img
                                                            className="left-image"
                                                            src="assets1/images/icons/en-us.png"
                                                            alt="Language Images"
                                                        />
                                                        <span className="menu-item">English</span>
                                                        <i className="right-icon feather-chevron-down" />
                                                    </a>
                                                    <ul className="sub-menu">
                                                        <li>
                                                            <a href="#">
                                                                <img
                                                                    className="left-image"
                                                                    src="assets1/images/icons/fr.png"
                                                                    alt="Language Images"
                                                                />
                                                                <span className="menu-item">Français</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#">
                                                                <img
                                                                    className="left-image"
                                                                    src="assets1/images/icons/de.png"
                                                                    alt="Language Images"
                                                                />
                                                                <span className="menu-item">Deutsch</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="header-info">
                                            <ul className="rbt-dropdown-menu currency-menu">
                                                <li className="has-child-menu">
                                                    <a href="#">
                                                        <span className="menu-item">INR</span>
                                                        <i className="right-icon feather-chevron-down" />
                                                    </a>
                                                    <ul className="sub-menu hover-reverse">
                                                        <li>
                                                            <a href="#">
                                                                <span className="menu-item">EUR</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#">
                                                                <span className="menu-item">GBP</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="header-info">
                                <div className="top-bar-expended d-block d-lg-none">
                                    <button className="topbar-expend-button rbt-round-btn">
                                        <i className="feather-plus" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Header Top  */}
                <div className="rbt-header-wrapper header-space-betwween header-sticky">
                    <div className="container-fluid">
                        <div className="mainbar-row rbt-navigation-center align-items-center">
                            <div className="header-left rbt-header-content">
                                <div className="header-info">
                                    <div className="logo">
                                        <a href="/">
                                            <img
                                                src="assets1/images/logo/logo.png"
                                                alt="Education Logo Images"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="rbt-main-navigation d-none d-xl-block">
                                <nav className="mainmenu-nav">
                                    <ul className="mainmenu">
                                    <li className="has-dropdown has-menu-child-item">
                                            <a href="/">
                                                Home 
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                    {/* End Search Dropdown  */}
                </div>

                {/* End Side Vav */}
                <a className="rbt-close_side_menu" href="javascript:void(0);" />
            </header>

            <div className={`popup-mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                <div className="inner-wrapper">
                    <div className="inner-top">
                        <div className="content">
                            <div className="logo">
                                <a href="index.html">
                                    <img src="assets1/images/logo/logo.png" alt="Education Logo Images" />
                                </a>
                            </div>
                            <div className="rbt-btn-close">
                                <button
                                    className="close-button rbt-round-btn"
                                    onClick={toggleMobileMenu}
                                >
                                    <i className="feather-x" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <MobileMenuSection />
                </div>
            </div>
            <Outlet />
        </>

    );
};

export default ClientLayout;